import { render, staticRenderFns } from "./HowToStandardEn.vue?vue&type=template&id=22ec37e0&scoped=true&"
import script from "./HowToStandardEn.vue?vue&type=script&lang=js&"
export * from "./HowToStandardEn.vue?vue&type=script&lang=js&"
import style0 from "./HowToStandardEn.vue?vue&type=style&index=0&id=22ec37e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec37e0",
  null
  
)

export default component.exports